import React from 'react';
import MultiProductEditView from './MultiProductEditView.component';
import SingleProductEditView from './SingleProductEditView.component';

const ProductDetails = ({
	categoryOptions,
	refreshCategoryOptionsCallback,
	refreshProductsCallback,
	saveProductCallback,
	selectedProducts,
	storeStatus,
	tagOptions,
	onUpdateTagOptionsCallback,
	onDeleteProductCallback,
	collapseEastPanel,
}) => (
	<div className="products products-details">
		{selectedProducts.length === 1 ? (
			<SingleProductEditView
				key={selectedProducts[0].ProductID}
				categoryOptions={categoryOptions}
				refreshCategoryOptionsCallback={refreshCategoryOptionsCallback}
				refreshProductsCallback={refreshProductsCallback}
				product={selectedProducts[0]}
				saveProductCallback={saveProductCallback}
				storeStatus={storeStatus}
				tagOptions={tagOptions}
				onUpdateTagOptionsCallback={onUpdateTagOptionsCallback}
				onDeleteProductCallback={onDeleteProductCallback}
				collapseEastPanel={collapseEastPanel}
			/>
		) : (
			<MultiProductEditView
				productCount={selectedProducts.length}
				onDeleteProductCallback={onDeleteProductCallback}
				collapseEastPanel={collapseEastPanel}
			/>
		)}
	</div>
);

export default ProductDetails;
